import { Card, Flex, Text } from '@mantine/core';
import React from 'react';

interface SessionLoadingCardProps {
  title?: string;
  subtitle?: string;
}

export const SessionLoadingCard: React.FC<SessionLoadingCardProps> = ({
  title = 'Inizializzazione sessione...',
  subtitle = 'Preparazione in corso, attendere...',
}) => {
  return (
    <Card shadow='sm' withBorder p='md'>
      <Flex direction='column' align='center' gap='md'>
        <Text size='lg' fw={500}>
          {title}
        </Text>
        <Text size='sm' c='dimmed'>
          {subtitle}
        </Text>
      </Flex>
    </Card>
  );
};
